// Equipment top-view drawings keyed by catalog id.
//
// These are vector (SVG) files in /public/equipment — crisp at any zoom and
// in the PDF exports (the Vector PDF inlines them as real vector paths; the
// PNG/Blueprint exports rasterize them at high resolution).
//   - Lifts were traced from the original PNG wireframes (the 2-post as
//     filled outlines, 4-post / scissor / in-ground along each line's
//     centre, the mobile column redrawn by hand to the PNG's measurements).
//   - Everything else is drawn by hand in inches at its real footprint, so
//     each file's viewBox matches the catalog fw × fh exactly.
// To add one: drop an .svg in public/equipment and reference it here.
// The old PNGs are still in /public but nothing points at them any more.
const EQ = (file) => `/equipment/${file}.svg`;

export const EQ_IMAGES = {
  "2post": EQ("lift_2post"),
  "4post": EQ("lift_4post"),
  scissor: EQ("lift_scissor"),
  inground: EQ("lift_inground"),
  mobile_column: EQ("lift_mobile_column"),
  tc: EQ("tire_changer"),
  bal: EQ("wheel_balancer"),
  aln: EQ("wheel_aligner"),
  comp: EQ("compressor"),
  wash: EQ("parts_washer"),
  fjack: EQ("floor_jack"),
  odrain: EQ("oil_drain"),
  toolbox: EQ("tool_cabinet"),
  wbench: EQ("workstation"),
};

// Sidebar thumbnails use the same vector files (they scale down cleanly)
export const THUMB_IMAGES = { ...EQ_IMAGES };
